import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Header() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-top">
          <Link to="/" onClick={() => setMenuOpen(false)}>
            <img
              src="/cmlawlerlogo.png"
              alt="Public Insurance Adjuster | Cara M Lawler | TX License# 295678 | 6904 Tulane Dr. Austin TX 78723"
              className="logo-img"
            />
          </Link>
        </div>
        <div className="header-bottom">
          <button
            className={`menu-toggle ${menuOpen ? 'open' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle navigation menu"
            aria-expanded={menuOpen}
          >
            <span></span><span></span><span></span>
          </button>
          <nav className={`nav ${menuOpen ? 'nav-open' : ''}`}>
            {[['/', 'Home'], ['/contact', 'Contact'], ['/testimonials', 'Testimonials']].map(([path, label]) => (
              <Link
                key={path}
                to={path}
                className={`nav-link ${location.pathname === path ? 'active' : ''}`}
                onClick={() => setMenuOpen(false)}
              >
                {label}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
